import React, {useState, useEffect} from "react";
import { UrlPath } from "../../../config/routeConfig";
import { Tabs,Tab } from "react-bootstrap";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs"
import { TopBar } from "../../shared/topBar/TopBar";
import { ToastContainer } from "react-toastify";
import NewPortfolio from "./Tabs/NewPortfolio";
import NewAssets from "./Tabs/NewAssets";
import NewLots from "./Tabs/NewLots";
import LoadValuations from "./Tabs/LoadValuations";

function MarketableSecurities(){
    const Level = [{ BreadCrumb: "Admin >", Routes: `${UrlPath.Admin}` }, { BreadCrumb: "Marketable Securities Feed", Routes: `${UrlPath.MarketableSecurities}` }];
    const [activeTab,setActiveTab]=useState("New Portfolios");
    useEffect(()=>{
        document.title="Marketable Securities Feed";
    },[])
    return <>
        <TopBar label={"Marketable Securities Feed"} />
        <div className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <div className="container-fluid p-4">
            <Tabs activeKey={activeTab} onSelect={(key)=>{setActiveTab(key)}}>
                <Tab className="life-science rounded  border-top-0 "  eventKey="New Portfolios" title="New Portfolios" >
                 {activeTab==="New Portfolios" &&<NewPortfolio/>}
                </Tab>
                <Tab  className="life-science rounded  border-top-0" eventKey="New Assets" title="New Assets">
                {activeTab==="New Assets" && <NewAssets/>}
                </Tab>
                <Tab className="life-science rounded  border-top-0" eventKey="New Lot" title="New Lot">
                {activeTab==="New Lot" && <NewLots/>}
                </Tab>
                <Tab className="life-science rounded  border-top-0" eventKey="Load Valuations" title="Load Valuations">
                {activeTab==="Load Valuations" && <LoadValuations/>}
                </Tab>
            </Tabs>
            </div>
        </div>
        <ToastContainer/>
    </>
}

export default MarketableSecurities;